<template>
  <div :class="getSliderClass" class="slider">
    <SliderItem
      v-for="(item, index) in items"
      :key="index"
      :class="{ tall: index < shouldBeTall }"
    >
      <component
        :is="cardType"
        :blok="item"
        :card-type="sliderCardType"
        :class="{ small: index >= shouldBeTall }"
        :content-type="contentType"
      />
    </SliderItem>
    <SliderItem
      :class="{ tall: totalLoadedItems < totalSlides }"
      class="slider-item__cta"
    >
      <CtaCard
        :card-title="cardTitle"
        :class="{ small: totalLoadedItems >= totalSlides }"
        :cta-label="cardCta"
        :cta-link="cardLink"
        no-media
      />
    </SliderItem>
  </div>
</template>

<script setup lang="ts">
import type { ISbStoryData } from 'storyblok'
import type { CardProps } from '~/storyblok/block/BlockCards.vue'
import type { BlockToolQuickLinkStoryblok } from '~/types/storyblok'
type SliderComponentItem =
  | ISbStoryData
  | BlockToolQuickLinkStoryblok
  | AudienceData
  | TopicData
  | CardProps

const props = withDefaults(
  defineProps<{
    items?: SliderComponentItem[]
    totalSlides?: string
    contentType?: string
    ctaTitle?: string
    ctaLink?: string
  }>(),
  {
    items: () => [],
    totalSlides: '4',
    contentType: 'Cta',
    ctaTitle: '',
    ctaLink: '',
  },
)
const slideOffset = ref(1)
const totalSlides = computed(() => Number(props.totalSlides))

const shouldBeTall = computed(
  () =>
    totalSlides.value -
    slideOffset.value -
    (totalLoadedItems.value - totalSlides.value),
)

const totalLoadedItems = computed(() => props.items.length)
const cardType = computed(() => props.contentType + 'Card')
const sliderCardType = computed(() =>
  props.contentType === 'featured-topics' ? 'vertical' : '',
)
const cardTitle = computed(() => 'View all\n' + props.ctaTitle + ' on Compass')
const cardCta = computed(() => 'All ' + props.ctaTitle)
const cardLink = computed(() =>
  props.contentType === 'Cta' || props.contentType === 'related'
    ? '/' + props.ctaLink || '/'
    : '/' + props.contentType,
)
const getSliderClass = computed(
  () => 'slider--' + props.contentType.toLowerCase(),
)
</script>
